<template>
  <div class="header-panel">
    <div class="header-panel-user" v-popover:popover>
      <div class="user">
        <img class="user-avatar" alt="user's avatar" :src="userInfo.avatar" />
      </div>
    </div>
    <el-popover
      ref="popover"
      trigger="hover"
      placement="bottom-end"
      popper-class="popper_styles_of_navigator"
      :open-delay="0"
      :visible-arrow="false"
      :width="240"
    >
      <div class="popover_content_of_navigator">
        <div class="wrapper username">用户名：{{ userInfo.username }}</div>
        <!--<div class="wrapper logout" @click="onLogout">退出</div>-->
      </div>
    </el-popover>
  </div>
</template>

<script>
import UserAvatar from '@/assets/icons/user_avatar.png';

export default {
  name: "HeaderUserInfo",
  data(){
    return {
      userInfo: {
        avatar: UserAvatar,
        username: ''
      }
    }
  },
  created() {
    this.initUserInfo();
  },
  methods: {
    initUserInfo() {
      const userInfo = this.$store.state.user.userInfo;
      if (userInfo && userInfo.userName) {
        this.userInfo.username = userInfo.userName;
      }
    },
    /**
     * 退出登录。清空 user token 和 user 信息，返回首页
     */
    onLogout() {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      sessionStorage.clear();
      location.replace(process.env.VUE_APP_INDEX_ADDRESS);
    },
  }
}
</script>

<style scoped lang="scss">
$height-header: 50px;
.header{
  &-panel {
    &-user {
      width: 80px;
      height: $height-header;
      background-color: #0e1726;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: 0.1s ease-in-out;

      &:hover {
        background-color: #1bbcf3;
      }

      &-avatar {
        width: 27px;
        height: 27px;
      }
    }
  }
}
</style>
